import script from "./WCProductRowModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCProductRowModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCProductRowModern.vue?vue&type=style&index=0&id=055d7e5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055d7e5a"]])

export default __exports__